/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Draft_Empty_No_Org_TemplateInputs */

const cs_draft_empty_no_org_template = /** @type {(inputs: Draft_Empty_No_Org_TemplateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tato organizace zatím nemá šablonu pro tento typ dokumentu.`)
};

const en_draft_empty_no_org_template = /** @type {(inputs: Draft_Empty_No_Org_TemplateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This organization has no template for this document type yet.`)
};

/**
* | output |
* | --- |
* | "This organization has no template for this document type yet." |
*
* @param {Draft_Empty_No_Org_TemplateInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const draft_empty_no_org_template = /** @type {((inputs?: Draft_Empty_No_Org_TemplateInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Draft_Empty_No_Org_TemplateInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_draft_empty_no_org_template(inputs)
	return cs_draft_empty_no_org_template(inputs)
});